import { grid } from '../../script'

let arrangeTabs = () => {

	if ( window.matchMedia( '(min-width: ' + grid.mediumScreen + ')' ).matches && $( '.tabs' ).hasClass('mobile') ) {

		// Add class to cache changes
		$('.tabs').addClass('desktop');

		/**
		 * If desktop, re-arrange tabs under the corresponding parent
		 */
		$('.tabs__label').each( ( i, item ) => {
			let $this = $( item );
			let $tabs = $this.parents('.tabs');
			$tabs.find('.tabs__labels').append( $this );
		})

		$('.tabs__content-item').each( ( i, item ) => {
			let $this = $( item );
			let $tabs = $this.parents('.tabs');
			$tabs.find('.tabs__content').append( $this );
		})
		
	} else {

		// Add class to cache changes
		$('.tabs').addClass('mobile');

		/**
		 * If mobile, re-arrange tab content underneath the label
		 */
		$('.tabs__label').each( ( i, item ) => {
			let $this = $( item );

			let index = $this.attr('data-index');

			let $tabs = $this.parents('.tabs');
			let $content = $tabs.find( '.tabs__content-item[data-index="' + index + '"]' )

			$this.after( $content );
		})

	}

}

$( document ).ready(() => {

	arrangeTabs();

	window.addEventListener( 'resize', arrangeTabs )

	$( document ).on( 'click', '.tabs__label', (e) => {

		let $tabs = $( e.currentTarget ).parents('.tabs')

		$tabs.find('.tabs__label').removeClass('active').attr( 'aria-expanded', 'false' )
		$( e.currentTarget ).addClass('active').attr( 'aria-expanded', 'true' )

		let index = $( e.currentTarget ).attr('data-index')
		let $activeContent = $tabs.find( '.tabs__content-item[data-index="' + index + '"]' )

		$tabs.find('.tabs__content-item').removeClass('active').attr( 'aria-hidden', 'true' )
		$activeContent.addClass('active').attr( 'aria-hidden', 'false' )

	})

})


// WEBPACK FOOTER //
// ./assets/js/components/layout/tabs.js